import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * Renders MUI Icon button to remove cargo.
 * @returns {React.FC}
 */

const CargoItemActions = ({ deleteCargoItem, disabled }) => (
  <IconButton size="small" onClick={deleteCargoItem} disabled={disabled}>
    <Tooltip title="Delete cargo">
      <DeleteIcon />
    </Tooltip>
  </IconButton>
);

export default CargoItemActions;

CargoItemActions.propTypes = {
  deleteCargoItem: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
